import { Box } from "@mui/material";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { LIST_COMMENTAIRE, UPDATE_SURVEY } from "../../Utils/constant";
import survey from "../../assets/images/enquete.png";
import { updateOne } from "../../services/service";
import { useStoreCreneau } from "../../store/Paramettre/creneauStore";
import { useStoreApp } from "../../store/storeApp";
import { SubmitButton } from "../Widget/SubmitButton";
export const ValidationSurvey = ({ numeroTicket }) => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();
  const [isSubmit, setIsSubmit] = useState(false);

  const creneau = useStoreCreneau();
  const commentaire = useStoreApp();

  useEffect(() => {
    commentaire.getData(LIST_COMMENTAIRE, { page: 0, param: "", size: 10 }, "");
    creneau.creneau({ page: 0, param: "", size: 10 });
  }, []);

  const submit = (data) => {
    const requestData = {
      ...data,
      status: "REALISER",

      numeroTicket: numeroTicket,
    };
    setIsSubmit(true);
    updateOne(UPDATE_SURVEY, "", requestData)
      .then((res) => {
        if (res.status === 200) {
          toast.success("Rendez-vous de survey éffectuée");
          setIsSubmit(null);
        }
      })
      .catch((err) => {
        setIsSubmit(false);
        toast.error(err?.response?.data?.donnee);
      });
  };

  return (
    <>
      {isSubmit !== null ? (
        <form
          className="shadow-sm border rounded w-full p-8"
          onSubmit={handleSubmit(submit)}
        >
          <h1 class="text-amber-500 font-mtn text-2xl font-semibold tracking-tight">
            Realisation du servey
          </h1>
          <div className="my-4 space-y-4">
            <div className="my-2">
              <label className="form-control w-full">
                <div className="label">
                  <span className="label-text text-sm">
                    Resultat du servey <span className="text-red-500">*</span>
                  </span>
                </div>
                <select
                  {...register("resultat", { required: true })}
                  className="select select-bordered w-full"
                >
                  <option value={""} disabled selected>
                    Selectionnez un status
                  </option>
                  <option value={"OK"}>OK</option>
                  <option value={"NON_OK"}>Non OK</option>
                  <option value={"PARTIALY_OK"}>Partialy OK</option>
                </select>
              </label>
            </div>

            <label className="form-control w-full">
              <div className="label -mb-1">
                <span className="label-text">
                  Type commentaire <span className="text-red-500">*</span>
                </span>
              </div>
              <select
                {...register("typeCommentaire", { required: true })}
                className="select select-bordered w-full h-10"
              >
                <option value={""} disabled selected>
                  Selectionnez un type
                </option>
                {commentaire?.data?.data?.map((item) => (
                  <option value={item.id}>{item.designation}</option>
                ))}
              </select>
            </label>

            <div className="my-2">
              <label htmlFor="" className="text-sm">
                Commentaire
              </label>
              <textarea
                {...register("commentaire")}
                placeholder="Votre commentaire"
                className="textarea textarea-bordered textarea-sm w-full"
              ></textarea>
            </div>

            <div className="w-full">
              <SubmitButton isSubmit={isSubmit} label={"Enregistrer"} />
            </div>
          </div>
        </form>
      ) : (
        <div className="flex justify-center my-28 w-full">
          <div className="text-center">
            <img
              className="mx-auto"
              src={survey}
              height={80}
              width={80}
              alt=""
            />
            <p className="font-light mt-2  text-sm">Survey effectué</p>
          </div>
        </div>
      )}
      <div className="w-full mt-4">
        <hr />
        <div
          className="flex mt-4"
          sx={{ display: "flex", flexDirection: "row", pt: 2 }}
        >
          <Box sx={{ flex: "1 1 auto" }} />
          <button
            disabled={isSubmit !== null ? true : false}
            className={`bg-[#ffcb05] btn btn-sm py-1 px-2 font-medium rounded-lg `}
            onClick={() => {
              window.history.back();
              localStorage.removeItem("numeroTicket");
            }}
          >
            Terminer
          </button>
        </div>
      </div>
    </>
  );
};
